/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-regimen.reducer';

export const TreatmentRegimenDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentRegimenEntity = useAppSelector(state => state.treatmentRegimen.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentRegimenDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentRegimen.detail.title">TreatmentRegimen</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimen.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenEntity.id}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimen.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimen.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenEntity.endDate}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimen.status">Status</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenEntity.status}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimen.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimen.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimen.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimen.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentRegimen.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentRegimenEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRegimen.plan">Plan</Translate>
          </dt>
          <dd>{treatmentRegimenEntity.plan ? treatmentRegimenEntity.plan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRegimen.regimen">Regimen</Translate>
          </dt>
          <dd>{treatmentRegimenEntity.regimen ? treatmentRegimenEntity.regimen.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentRegimen.sequence">Sequence</Translate>
          </dt>
          <dd>{treatmentRegimenEntity.sequence ? treatmentRegimenEntity.sequence.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-regimen" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-regimen/${treatmentRegimenEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentRegimenDetail;
